import React, {useEffect} from 'react';
import {Route, Switch, useRouteMatch} from 'react-router';
import useDispatchWithResult from '../../../../hooks/useDispatchWithResult';
import {fetchRepresentante} from '../../../../store/empresa';
import EmpresaRepresentanteCreatePage from './_create';
import EmpresaRepresentanteDetailPage from './_detail';
import EmpresaRepresentanteEditPage from './_edit';

export default function EmpresaRepresentantePage() {
  const dispatch = useDispatchWithResult();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const id = match.params.id;

  useEffect(() => {
    dispatch(fetchRepresentante({empresaId, id}));
  }, [empresaId, id]);

  return (
      <Switch>
        <Route path="/*/empresas/:empresaId/representantes/:id/edit" component={EmpresaRepresentanteEditPage} />
        <Route path="/*/empresas/:empresaId/representantes/create" component={EmpresaRepresentanteCreatePage} />
        <Route path="/*/empresas/:empresaId/representantes/:id" component={EmpresaRepresentanteDetailPage} />
      </Switch>);
}
